import * as React from "react";
import { forwardRef } from "react";
const SvgTriangle = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "0 0 255 255", style: {
  enableBackground: "new 0 0 255 255"
}, xmlSpace: "preserve", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "arrow-drop-down" }, /* @__PURE__ */ React.createElement("polygon", { points: "0,63.75 127.5,191.25 255,63.75" })));
const ForwardRef = forwardRef(SvgTriangle);
export { ForwardRef as ReactComponent };
